(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["at-home-luxury"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[data-ath-collections-scroll]') : null;
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = document.getElementById(link.getAttribute('href').slice(1));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    block: 'start',
    inline: 'nearest'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tawash-wander')) {
  customElements.define('tawash-wander', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-wander-data]').textContent);
      this.groups = [...this.querySelectorAll('[data-option-group]')];
      this.select = this.querySelector('[data-variant-select]');
      this.submit = this.querySelector('[data-submit]');
      this.feedback = this.querySelector('[data-feedback]');
      this.mainImage = this.querySelector('.wa-main-image');
      this.dialog = this.querySelector('.wa-zoom');
      this.zoomImage = this.dialog.querySelector('img');
      this.querySelector('[data-native-picker]').hidden = true;
      this.querySelector('[data-custom-picker]').hidden = false;
      this.groups.forEach(group => group.addEventListener('change', () => this.updateVariant(true)));
      this.updateVariant(false);
      const zoomButton = this.querySelector('.wa-zoom-trigger');
      zoomButton.hidden = false;
      zoomButton.addEventListener('click', () => this.dialog.showModal());
      this.dialog.querySelector('button').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.querySelector('[data-wander-form]').addEventListener('submit', event => this.addToCart(event));
    }
    updateVariant(updateUrl) {
      const inputs = this.groups.map(group => group.querySelector('input:checked'));
      const values = inputs.map(input => input.value);
      const variant = this.data.variants.find(item => item.options.every((value, index) => value === values[index]));
      this.currentVariant = variant;
      this.groups.forEach((group,index) => { group.querySelector('[data-selected-option]').textContent = inputs[index].dataset.label; });
      this.select.value = variant ? String(variant.id) : '';
      this.submit.disabled = !variant || !variant.available;
      this.submit.textContent = !variant ? this.data.labels.unavailable : variant.available ? this.data.labels.buy : this.data.labels.soldOut;
      this.feedback.hidden = true;
      if (!variant) return;
      this.querySelector('[data-price]').textContent = variant.price;
      const compare = this.querySelector('[data-compare]');
      compare.hidden = !variant.compare;
      compare.textContent = variant.compare || '';
      const caption = inputs.map(input => input.dataset.label).join(' · ');
      this.querySelector('[data-image-caption]').textContent = caption;
      if (updateUrl && this.mainImage) {
        this.mainImage.removeAttribute('srcset');
        this.mainImage.src = variant.image;
      }
      if (this.mainImage) this.mainImage.alt = this.data.title + ' — ' + caption;
      this.zoomImage.src = variant.zoom;
      this.zoomImage.alt = this.data.title + ' — ' + caption;
      this.groups[0].querySelectorAll('label').forEach(label => {
        const input = label.querySelector('input');
        const match = this.data.variants.find(item => item.options[0] === input.value && item.options[1] === values[1]);
        const image = label.querySelector('img');
        if (match && image && updateUrl) { image.removeAttribute('srcset'); image.src = match.thumb; }
      });
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant',variant.id); window.history.replaceState({},'',url); }
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.pending || !this.currentVariant || !this.currentVariant.available) return;
      this.pending = true;
      const form = event.currentTarget;
      const body = new FormData(form);
      body.delete('return_to');
      this.submit.disabled = true;
      this.submit.textContent = this.data.labels.adding;
      this.submit.setAttribute('aria-busy','true');
      this.groups.forEach(group => { group.disabled = true; });
      this.feedback.hidden = true;
      try {
        const response = await fetch(form.action.replace(/\/add(?:\?.*)?$/, '/add.js'), { method:'POST',body,headers:{Accept:'application/json'} });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.data.labels.error);
        window.location.assign(this.dataset.cartUrl);
      } catch(error) {
        this.feedback.textContent = error.message || this.data.labels.error;
        this.feedback.hidden = false;
        this.submit.disabled = false;
        this.submit.textContent = this.data.labels.buy;
        this.pending = false;
        this.groups.forEach(group => { group.disabled = false; });
        this.submit.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
